import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';
import { KENTICO_CONSTS } from 'common/consts/kentico';

export default class Product extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get name() {
    return get(this, '_name.value', '');
  }

  get slug() {
    return get(this, '_product_slugs.taxonomyTerms[0].name', '/');
  }

  get structure() {
    return get(this, '_structure', []);
  }

  get shareLinks() {
    return get(this, '_share_links', []);
  }

  get googlePlayShareLink() {
    const link = get(this, '_share_links', [])
      .find(shareLink => shareLink.marketCodeName === KENTICO_CONSTS.MARKET_GOOGLE_PLAY_CODENAME);
    return link ? link.link : '';
  }

  get appStoreShareLink() {
    const link = get(this, '_share_links', [])
      .find(shareLink => shareLink.marketCodeName === KENTICO_CONSTS.MARKET_APP_STORE_CODENAME);
    return link ? link.link : '';
  }

  get SEO() {
    return get(this, '_product___seo[0].model', []);
  }
}



// WEBPACK FOOTER //
// ./src/models/Product.model.js